// extracted by mini-css-extract-plugin
export default {"cls1":"Comment-cls1__Dn","cls2":"Comment-cls2_U8T Comment-cls1__Dn"};